import Radom, {
  CheckoutFunnelRail,
  CheckoutFunnelSourceType,
  CheckoutFunnelStep
} from '../api/Radom'

const SESSION_KEY_PREFIX = 'radom:checkout-funnel-session'

const generateSessionKey = (): string => {
  if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
    return crypto.randomUUID()
  }

  return `${Date.now()}-${Math.random().toString(36).slice(2)}`
}

const getClientMetadata = (): Record<string, unknown> => {
  if (typeof window === 'undefined') {
    return {}
  }

  const viewportWidth = window.innerWidth
  const viewportHeight = window.innerHeight
  const isTouch = window.matchMedia('(pointer: coarse)').matches

  let referrerHost: string | undefined
  if (document.referrer) {
    try {
      referrerHost = new URL(document.referrer).hostname
    } catch {
      referrerHost = undefined
    }
  }

  const deviceType =
    viewportWidth <= 768
      ? 'mobile'
      : viewportWidth <= 1024
        ? 'tablet'
        : 'desktop'

  return {
    checkoutClient: 'pay-web',
    pagePath: window.location.pathname,
    referrerHost,
    viewportWidth,
    viewportHeight,
    deviceType,
    inputMode: isTouch ? 'touch' : 'mouse',
    locale: typeof navigator !== 'undefined' ? navigator.language : undefined,
    timezone: Intl.DateTimeFormat().resolvedOptions().timeZone
  }
}

export const getCheckoutFunnelSessionKey = (
  sourceType: CheckoutFunnelSourceType,
  sourceId: string
): string => {
  if (typeof window === 'undefined') {
    return `${sourceType}-${sourceId}`
  }

  const storageKey = `${SESSION_KEY_PREFIX}:${sourceType}:${sourceId}`
  const existing = window.sessionStorage.getItem(storageKey)
  if (existing && existing.length > 0) {
    return existing
  }

  const sessionKey = `${sourceType}-${sourceId}-${generateSessionKey()}`
  window.sessionStorage.setItem(storageKey, sessionKey)
  return sessionKey
}

export const trackCheckoutFunnelStep = async ({
  sourceType,
  sourceId,
  rail,
  step,
  metadata
}: {
  sourceType: CheckoutFunnelSourceType
  sourceId: string
  rail: CheckoutFunnelRail
  step: CheckoutFunnelStep
  metadata?: Record<string, unknown>
}): Promise<void> => {
  const trackEvent = (Radom as any)?.trackCheckoutFunnelEvent
  if (typeof trackEvent !== 'function') {
    return
  }

  try {
    await trackEvent.call(Radom, {
      sourceType,
      sourceId,
      rail,
      step,
      sessionKey: getCheckoutFunnelSessionKey(sourceType, sourceId),
      metadata: {
        ...getClientMetadata(),
        ...metadata
      }
    })
  } catch (err) {
    console.warn('Failed to track checkout funnel step', err)
  }
}
